module.exports = "import React from 'react';\nimport BrandBand from '~/components/brand-band'; // `~` is replaced with design-system-react at runtime\n\nclass Example extends React.Component {\n\trender() {\n\t\treturn <BrandBand id=\"brand-band-default\" />;\n\t}\n}\n\nExample.displayName = 'BrandBandExample';\n\nexport default Example; // export is replaced with `ReactDOM.render(<Example />, mountNode);` at runtime\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/@salesforce/design-system-react/components/brand-band/__examples__/default.jsx
// module id = 764
// module chunks = 0